<form nz-form style="padding-top:12px;padding-right:12px"   autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Mã</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="group.groupCode" [ngModelOptions]="{standalone: true}" type="text" placeholder="Nhập mã" [jAutofocus]>
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS" nzRequired>Tên nhóm</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="group.groupName" [ngModelOptions]="{standalone: true}" type="text" placeholder="Nhập tên">
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24">Hoạt động:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="group.isActivity" [ngModelOptions]="{standalone: true}">
              <label nz-radio [nzValue]="true">Có</label>
              <label nz-radio [nzValue]="false">Không</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24">Cấp:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="group.disEducationAndTrainingFor" [ngModelOptions]="{standalone: true}">
              <ng-container *ngFor="let list of ListEnum">
                <label nz-radio [nzValue]="list.id"> {{list.educationAndTrainingForName}}</label>
                </ng-container> 
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      

  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>
